import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=0b6f5fe1&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"
import style0 from "./Action.vue?vue&type=style&index=0&id=0b6f5fe1&lang=scss&scoped=true&"
import style1 from "./Action.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f5fe1",
  null
  
)

export default component.exports